var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[(_vm.url != '/cloud/study')?_c('global-nav'):_vm._e(),_c('router-view'),(_vm.url != '/cloud/study')?_c('footer-nav'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }